import { createFileRoute } from '@tanstack/react-router';
import { requireAuth } from '../lib/requireAuth';
import CloudinaryUploader from '../components/CloudinaryUploader';
import { usePageMeta } from '../hooks/usePageMeta';
import { AdminNav } from '../components/AdminNav';

export const Route = createFileRoute('/upload')({
  beforeLoad: () => requireAuth('/upload'),
  component: UploadPage,
});

function UploadPage() {
  usePageMeta('Upload | Boyden Renovations', undefined, true);

  return (
    <div>
      <AdminNav />
<CloudinaryUploader />
    </div>
  );
}
